/**
 * The not-found piece's standard look, in the studio's look (the home's heading and link styles).
 * Draws the behavior half's state and calls its actions; holds no rule.
 */

import { partsOf, pieceRoot } from '../../contract/runtime';
import { onLink } from '../../ui/onLink';
import shared from '../../styles/shared.module.css';
import { Icon } from '../../ui/Icon';
import type { NotFoundRuntime } from './useNotFound';
import css from './NotFound.module.css';
import { contract } from './contract';

const part = partsOf(contract);

export function NotFoundView({ actions, options }: NotFoundRuntime) {
  return (
    <section className={css.notFound} aria-labelledby="notFoundTitle" {...pieceRoot(contract)} {...part('section')}>
      <div className={`${shared.wrap} ${css.inner}`}>
        <h1 className={shared.h2} id="notFoundTitle" {...part('heading')}>
          {options.heading ?? 'Page not found'}
        </h1>
        {options.text && (
          <p className={css.text} {...part('text')}>
            {options.text}
          </p>
        )}
        <a className={`${shared.go} ${css.home}`} href="/" onClick={onLink(actions.goHome)} {...part('home')}>
          <u>{options.linkLabel ?? 'Go to the home page'}</u>
          <Icon name="arrow" small />
        </a>
      </div>
    </section>
  );
}
